/* eslint-disable no-nested-ternary */
import { formatVlanIdsWithUt } from '../export-helpers';
import {
  formatIp,
  type PdfCell,
  MERGED_CELL_STYLES,
  createPdfTableBlob,
} from './pdf-common';
import { type NodeExportData, type ExportHeaderInfo } from './types';

export const buildSwitchesPdfBlob = (
  switchesData: NodeExportData[],
  filename: string,
  headerInfo?: ExportHeaderInfo,
): { blob: Blob; filename: string } => {
  const head = [
    'Name',
    'Model',
    'IP',
    'Port',
    'Connect Node',
    'Connect Port',
    'VLAN IDs',
    'PoE',
    'DHCP',
    'Notes',
  ];
  const body: PdfCell[][] = [];

  switchesData.forEach((s) => {
    const ipStr = s.IP.map(formatIp).filter(Boolean).join('\n') || '-';
    const maxRows = Math.max(s.IP.length, s.Port.length, 1);

    for (let i = 0; i < maxRows; i += 1) {
      const p = s.Port[i] || {};
      const vlanStr = p.vlanIds?.length
        ? formatVlanIdsWithUt(p.vlanIds, p.untaggedVlan)
        : '';
      const poeStr =
        p.isPoeCapable === false ? '-' : p.poeEnabled ? 'Yes' : 'No';
      const portCells = [
        p.name || '',
        p.connectNode || '',
        p.connectPort || '',
        vlanStr,
        poeStr,
        p.dhcpEnabled ? 'Yes' : 'No',
      ];
      if (i === 0) {
        body.push([
          { content: s.Name, rowSpan: maxRows, styles: MERGED_CELL_STYLES },
          { content: s.Model, rowSpan: maxRows, styles: MERGED_CELL_STYLES },
          { content: ipStr, rowSpan: maxRows, styles: MERGED_CELL_STYLES },
          ...portCells,
          {
            content: s.Notes || '',
            rowSpan: maxRows,
            styles: MERGED_CELL_STYLES,
          },
        ]);
      } else {
        body.push(portCells);
      }
    }
  });

  return createPdfTableBlob(head, body, filename, headerInfo);
};
